import state from './boschpanel.state'
import mutations from './boschpanel.mutations'
import actions from './boschpanel.actions'

export default {
  state,
  mutations,
  actions
}
